var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2353_2992)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2353_2992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.66602H11.8333L10.5 0.666016H6.5L5.16667 2.66602H2.5C1.96957 2.66602 1.46086 2.87673 1.08579 3.2518C0.710714 3.62687 0.5 4.13558 0.5 4.66602L0.5 12.666C0.5 13.1964 0.710714 13.7052 1.08579 14.0802C1.46086 14.4553 1.96957 14.666 2.5 14.666H14.5C15.0304 14.666 15.5391 14.4553 15.9142 14.0802C16.2893 13.7052 16.5 13.1964 16.5 12.666V4.66602C16.5 4.13558 16.2893 3.62687 15.9142 3.2518C15.5391 2.87673 15.0304 2.66602 14.5 2.66602ZM8.5 11.9993C7.84073 11.9993 7.19626 11.8039 6.6481 11.4376C6.09994 11.0713 5.67269 10.5507 5.4204 9.94163C5.16811 9.33254 5.1021 8.66232 5.23072 8.01571C5.35933 7.36911 5.6768 6.77517 6.14298 6.30899C6.60915 5.84282 7.2031 5.52535 7.8497 5.39673C8.4963 5.26811 9.16652 5.33413 9.77561 5.58642C10.3847 5.83871 10.9053 6.26595 11.2716 6.81412C11.6378 7.36228 11.8333 8.00674 11.8333 8.66602C11.8333 9.55007 11.4821 10.3979 10.857 11.023C10.2319 11.6482 9.38406 11.9993 8.5 11.9993Z",
    fill: "#249CF3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2353_2992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2353_2992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.e0930402d26413992f65497f21a51620.svg";
export { ForwardRef as ReactComponent };